import { ModelCategory } from '@paragon/contract-library';

import { GenericModelSchema } from '../ModelSchema';

export const DimensionSchema = new GenericModelSchema('dimension', {
  category: ModelCategory.ComponentDesignData,

  properties: {},
});
